"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var randomNumber = exports.randomNumber = function randomNumber() {
  return Math.random().toFixed(15).slice(2);
};